/* eslint-disable import/prefer-default-export */
export { default as storePagination } from './store-pagination'
